import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Announcement } from '../../models/announcement/announcement.model';
import { Customer } from '../../models/customer/customer-model'
import { CustomerService } from '../../services/customer/customer.service';
import { AnnouncementService } from '../../services/announcement/announcement.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { DATE } from 'ngx-bootstrap/chronos/units/constants';

@Component({
    selector: 'app-edit-announcement',
    templateUrl: './edit-announcement.component.html',
    styleUrls: ['./edit-announcement.component.css']
})
/** edit-announcement component*/
export class EditAnnouncementComponent {
  public announcement = new Announcement();
  public customerList: Customer[];
  public startDateElement: any;
  public endDateElement: any;
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
    /** edit-announcement ctor */
  constructor(private _avRoute: ActivatedRoute,
    private readonly announcementService: AnnouncementService,
    private readonly customerService: CustomerService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef,
    private _router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("announcement").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.announcement.isActive = true;
            this.announcement.customerID = 0;
            this.getVendors();
            if (this._avRoute.snapshot.params["id"]) {
              this.getAnnouncementById(this._avRoute.snapshot.params["id"]);
            }
          }
          else {
            this._router.navigate(["/announcement-list"]);
          }
        }
        else {
          this._router.navigate(["/announcement-list"]);
        }
      }
    )
    this.minDate = new Date();
    this.maxDate = new Date();
    this.endMaxDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
  }
  getAnnouncementById(id: string) {
    this.announcementService.GetAnnouncementById(id).subscribe(
      data => {
        this.announcement = data;
        this.announcement.startDate = this.formatDate(this.announcement.startDate);
        this.announcement.endDate = this.formatDate(this.announcement.endDate);
      }
    )
  }
   formatDate(date: string): string {
    let newDate: any = date.split('-');
    let days: number = parseInt(newDate[2]);
    let months: number = parseInt(newDate[1]);
    let year: number = parseInt(newDate[0]);
    return months + "/" + days + "/" +year;
  }
  getVendors() {
    this.customerService.getVendorsList().subscribe(
      data => {
        this.customerList = data;
      }
    )
  }

  onSubmit() {
    this.startDateElement = document.getElementById("startDate") as HTMLElement;
    this.endDateElement = document.getElementById("endDate") as HTMLElement;
    this.announcement.startDate = this.startDateElement.value;
    this.announcement.endDate = this.endDateElement.value;
    this.toastr.success('Announcement updated successfully.', 'Success');
    this.announcementService.UpdateAnnouncement(this.announcement);
  }
  selectStartDate(e) {
    if (e != null) {
      this.announcement.startDate = e;
    //  this.minDate = e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
    //  this.endMaxDate.setDate(this.maxDate.getDate() + 1);
    }
  }
  selectEndDate(e) {
    if (e != null) {
    this.announcement.endDate = e;
       }
 }

}



// WEBPACK FOOTER //
// ./src/app/announcement-components/edit-announcement/edit-announcement.component.ts